export class FindRetailerLink {
	constructor( element ) {
		this.element = element;

		this.summaryInnerWrapper = this.element.querySelector( '.summary-inner-wrapper' );
		this.findRetailerText = window.QalaB2bWholesale.translations.retailerTranslations.findRetailer;
		this.findRetailerAnchor = window.QalaB2bWholesale.settings?.b2b_retailer_settings_find_retailers_anchor_link;
		this.gMapBlockExists = this.element.querySelector( '.wp-block-qala-b2b-wholesale-retailers-gmap' );
	}

	init() {
		if ( ! this.summaryInnerWrapper || ! this.gMapBlockExists ) {
			return;
		}

		this.addFindRetailerLink();
		this.enableSmoothScroll();
	}

	/**
	 * Add "Find retailer" link to the product
	 */
	addFindRetailerLink() {
		const findRetailerButton = document.createElement( 'div' );
		findRetailerButton.classList.add( 'wp-block-button', 'is-style-primary-underline' );

		const findRetailerLink = document.createElement( 'a' );
		findRetailerLink.classList.add( 'wp-block-button__link' );
		findRetailerLink.href = `#${ this.findRetailerAnchor }`;
		findRetailerLink.textContent = this.findRetailerText;

		findRetailerButton.appendChild( findRetailerLink );
		this.summaryInnerWrapper.appendChild( findRetailerButton );
	}

	/**
	 * Enable smooth scroll page wide.
	 */
	enableSmoothScroll() {
		document.documentElement.style.scrollBehavior = 'smooth';
	}
}
